import { render, staticRenderFns } from "./ImprestList.vue?vue&type=template&id=5d1c0ba1&scoped=true"
import script from "./ImprestList.vue?vue&type=script&lang=js"
export * from "./ImprestList.vue?vue&type=script&lang=js"
import style0 from "./ImprestList.vue?vue&type=style&index=0&id=5d1c0ba1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1c0ba1",
  null
  
)

export default component.exports